import axios from "axios";
// stage
// export let base_url =
// 	"https://qxx0fq0pb9.execute-api.us-west-2.amazonaws.com/stg";
// export let kroger_redirect_uri = "http://localhost:8080/auth";
// export let redirect_uri = "http://localhost:8080/cognito/login";
// export let client_id = "4hrsnaqe4i77roj2gh3sgs0p3h";
// production
export let base_url = "https://etutw2ioni.execute-api.us-west-2.amazonaws.com/stg";
export let kroger_redirect_uri = "https://tastummy-planner.tisourit.com/auth";
export let redirect_uri = "https://tastummy-planner.tisourit.com/cognito/login";
export let token_endpoint = "https://tastummy.auth.us-west-2.amazoncognito.com/oauth2/token";
export let client_id = "707si96rsp3o70m83hrpc0lml4";
export let kroger_client_id = "tastummy-0ab00026ce2cb8bec6805bb5ad6672861079032102993069067";
export const login = (code) => {
    return axios({
        method: "POST",
        url: `${base_url}/public/token`,
        data: { code },
    });
};
export const refresh_login = (token) => {
    return axios({
        baseURL: base_url,
        method: "POST",
        url: `${base_url}/public/refresh`,
        data: { token },
    });
};
